export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error) => {
    // handle error, e.g. report to a service
    posthogCatcher(error);
  };

  // Also possible
  nuxtApp.hook('vue:error', (error) => {
    posthogCatcher(error);
    // handle error, e.g. report to a service
  });
});
